import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useDispatch, useSelector } from 'react-redux';

import { PromoItemContainer } from './parts/PromoItemContainer';
import { PromosBanner } from './parts/PromosBanner';
import { ToggleButton } from './parts/ToggleButton';
import { trackMorePromosClick } from './tracking';
import { openPromoInfo } from '../../actions/promoInfo';
import { Layout } from '../../components/Layout';
import { Promos } from '../../components/Promos';
import { getDisplayName, getNewbuildingId } from '../../selectors/newbuilding';
import { selectNewbuildingPromos } from '../../selectors/newbuildingMorgageCalculator';
import { IPromo } from '../../types/newbuilding/promos';
import { trackClickPromoBlock } from '../../utils/analytics';
import { trackPromoOffersShow } from '../MortgageSection/tracking';
import { SeoPromosLink } from '../SeoPromosLink';

export const PromosSectionContainer: React.FC = () => {
  const promos = useSelector(selectNewbuildingPromos);
  const newbuildingId = useSelector(getNewbuildingId);
  const title = useSelector(getDisplayName);
  const dispatch = useDispatch();

  const handlePromosExpand = React.useCallback((opened: boolean) => {
    if (opened) {
      trackMorePromosClick();
    }
  }, []);

  const openPromo = React.useCallback(
    (promo: IPromo) => {
      dispatch(openPromoInfo({ promo }));
      trackClickPromoBlock(promo, newbuildingId);
    },
    [dispatch, newbuildingId],
  );

  const onBlockShow = React.useCallback(() => {
    trackPromoOffersShow(promos, newbuildingId);
  }, [promos, newbuildingId]);

  return (
    <Layout>
      <ActionAfterViewObserver callback={onBlockShow} triggerOnce>
        <Promos
          banner={<PromosBanner />}
          seoLink={<SeoPromosLink />}
          title={`Акции в ${title}`}
          Button={ToggleButton}
          onChangeOpen={handlePromosExpand}
        >
          {promos.map((promo: IPromo) => (
            <PromoItemContainer key={promo.uniquePromoId} promo={promo} onClick={openPromo} />
          ))}
        </Promos>
      </ActionAfterViewObserver>
    </Layout>
  );
};
